import { render, staticRenderFns } from "./ParticipantsQueue.vue?vue&type=template&id=8bfc8b9c&scoped=true&"
import script from "./ParticipantsQueue.vue?vue&type=script&lang=js&"
export * from "./ParticipantsQueue.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantsQueue.vue?vue&type=style&index=0&id=8bfc8b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfc8b9c",
  null
  
)

export default component.exports